import {
	applyMultiPskFilter,
	focusMultiPsk,
	openMultiPskSection,
} from './adapter';
import {
	openMultiPskCreateModal,
	openMultiPskDeleteModal,
	openMultiPskEditModal,
} from './modal';
import {resolveMultiPskProfiles} from './resolver';

/**
 * Multi PSK profiles.
 *
 * The reference resolver was already here, so an SSID could name its
 * Multi PSK profile. This adds the section itself.
 *
 * The row action reads View, but the modal it opens is titled Edit
 * and is the only place a profile's PSKs can be changed - so the
 * capability is edit, and "view" reaches it too. Editing one PSK
 * inside that modal is a row within a row, and is not offered.
 */
const multiPskPlugin = {
	id: 'multi_psk',
	version: 1,
	commandVersion: 1,
	resource: 'multi_psk',
	operations: ['options', 'list', 'search', 'create', 'edit', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.multi_psks': openMultiPskSection,
	},
	resolvers: {
		multi_psk: resolveMultiPskProfiles,
	},
	filters: {
		multi_psk: (command) => applyMultiPskFilter(command.params?.query),
	},
	focusHandlers: {
		multi_psk: (command) => focusMultiPsk(command.params?.entity_id),
	},
	modals: {
		'multi_psk.create': openMultiPskCreateModal,
		'multi_psk.edit': openMultiPskEditModal,
		'multi_psk.delete': openMultiPskDeleteModal,
	},
};

export default multiPskPlugin;
